import { useContext, useMemo } from "react";
import { InternationalizationContext } from "./InternationalizationContext";
import * as translations from "./translations.json";

type TranslationKey = keyof (typeof translations)[keyof typeof translations];
type TranslationValues = Record<string, string | number>;

export interface Translator {
  (key: TranslationKey, values?: TranslationValues): string;
}

const interpolate = (text: string, values: TranslationValues = {}) =>
  text.replace(/\{(\w+)\}/g, (placeholder, name: string) =>
    name in values ? String(values[name]) : placeholder,
  );

const translate =
  (language: keyof typeof translations): Translator =>
  (key, values) =>
    interpolate(translations[language][key], values);

export const useTranslator = (): Translator => {
  const { language } = useContext(InternationalizationContext);

  return useMemo(() => translate(language), [language]);
};
